// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__-u+6z"};